import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Label } from 'flowbite-react';
import Select from 'react-select';

const MatchFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const sortBy = searchParams.get('sortBy');

	const options = [
		{ value: 'bestMatch', label: 'Best Match' },
		{ value: 'percentile', label: 'Percentile' },
		// { value: 'availability', label: 'Availability' },
		// { value: 'salarylth', label: 'Salary: Low to High' },
		// { value: 'salaryhlt', label: 'Salary: High to Low' },
	];

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!sortBy}
					placeholder={sortBy ? options?.find(e => e?.value?.toString() === sortBy?.toString())?.label : 'Best Match'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map(option => (
								<Button
									key={option?.value}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
									}}
									onClick={() => {
										if (handlePopoverClose) handlePopoverClose();
										if (option?.value === sortBy) return;
										searchParams.set('sortBy', option?.value?.toString());
										setSearchParams(searchParams);
									}}
								>
									{option?.label}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Sort by</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Best Match"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => sortBy?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('sortBy', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default MatchFilterInput;
